import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

import ChooseColor from "../creator/ChooseColor";
import ChooseSystem from "../creator/ChooseSystem";

import {
  setDefaultColor,
  setDefaultSystem
} from "../../store/actions/defaults";

const useStyles = makeStyles(theme => ({
  box: {
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(3)
    }
  }
}));

function DefaultValues({ color, setDefaultColor, setDefaultSystem, system }) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.box} display="flex">
      <ChooseSystem
        label={t("default.system")}
        selectedSystem={system}
        setSelectedSystem={setDefaultSystem}
      />
      <ChooseColor
        label={t("default.color")}
        selectedColor={color}
        setSelectedColor={setDefaultColor}
      />
    </Box>
  );
}

const mapStateToProps = ({ defaults: { color, system } }) => {
  return { color, system };
};
const mapDispatchToProps = dispatch => {
  return {
    setDefaultColor: value => dispatch(setDefaultColor(value)),
    setDefaultSystem: value => dispatch(setDefaultSystem(value))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DefaultValues);
